import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Shield } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";
import DocumentAnalysis from "@/components/admin/risk/DocumentAnalysis";
import BehaviorAnalysis from "@/components/admin/risk/BehaviorAnalysis";
import RiskTable from "@/components/admin/risk/RiskTable";

const RiskAssessment = () => {
  const { toast } = useToast();
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [risks] = useState([
    {
      id: 1,
      user: "John Doe",
      type: "Identity Risk",
      level: "High",
      detectedAt: "2024-02-20",
    },
    {
      id: 2,
      user: "Jane Smith",
      type: "Transaction Risk",
      level: "Medium",
      detectedAt: "2024-02-19",
    },
  ]);

  const handleBehaviorAnalysis = async (userId: number) => {
    setIsAnalyzing(true);
    try {
      toast({
        title: "Behavior Analysis Complete",
        description: "User behavior pattern analyzed successfully.",
      });
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Analysis Failed",
        description: "There was an error analyzing user behavior.",
      });
    } finally {
      setIsAnalyzing(false);
    }
  };

  return (
    <div className="h-full min-h-screen p-6 space-y-8">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold">AI-Powered Risk Assessment</h1>
        <Shield className="h-8 w-8 text-primary" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <DocumentAnalysis />
        <BehaviorAnalysis />
      </div>

      <Card className="p-8 mt-8">
        <h2 className="text-2xl font-semibold mb-6">Risk Analysis Results</h2>
        <RiskTable
          risks={risks}
          onAnalyze={handleBehaviorAnalysis}
          isAnalyzing={isAnalyzing}
        />
      </Card>
    </div>
  );
};

export default RiskAssessment;